import React, { Fragment } from "react";

import { Img, Text } from "components";
import HaierLogo from "../../assets/images/haier_logo.png";

const l1 = [
  'Ground floor, Salamander Tower, Samora',
  'haierinfo@gsmgroup.africa',
  '+2557450000000'
]

const l2 = [
  "About Us",
  "Contact Us",
  "Privacy Policy",
  "Refund Policy",
]

const l3 = [
  "Instagram",
  "Facebook",
  "x",
  "WhatsApp",
]

const Footer1 = (props) => {
  return (
    <footer className={props.className} style={{background: '#000'}}>
      <div
        className="flex sm:flex-col flex-row md:gap-10 items-center md:items-start justify-between md:justify-center mx-auto my-7 w-[97%]">
        <ul
          className=" flex flex-col items-start justify-start pr-[7px] py-[7px] md:w-full common-column-list">
          <Img style={{ maxWidth: 80 }} src={HaierLogo} className="mb-3" />
          {l1.map(x => {
            return (
              <Fragment key={x}>
                <li className="flex-grow mb-3">
                  <Text
                    className="text-base text-white-A700_dd tracking-[0.50px]"
                    size="txtInterRegular16WhiteA700dd"
                  >
                    {x}
                  </Text>
                </li>
              </Fragment>
            );
          })}
        </ul>
        <ul
          className=" flex flex-col justify-center items-center pr-1.5 py-1.5 md:w-full">
          <div className="flex items-start justify-start flex-col">
            {l2.map(x => {
              return (
                <Fragment key={x}>
                  <li className="flex-grow mb-3">
                    <Text
                      className="text-base text-white-A700_dd tracking-[0.50px]"
                      size="txtInterRegular16WhiteA700dd"
                    >
                      {x}
                    </Text>
                  </li>
                </Fragment>
              );
            })}
          </div>
        </ul>
        <ul
          className=" flex flex-col items-end justify-end pr-1.5 py-1.5 md:w-full">
          {
            l3.map(x => {
              return (
                <Fragment key={x}>
                  <li className="mb-3">
                    <Text
                      className="text-base text-white-A700_dd tracking-[0.50px]"
                      size="txtInterRegular16WhiteA700dd"
                    >
                      {x}
                    </Text>
                  </li>
                </Fragment>
              );
            })
          }
        </ul>
      </div>
    </footer>
  );
};

Footer1.defaultProps = {};

export default Footer1;
